// extracted by mini-css-extract-plugin
module.exports = {"status":"TransactionStatusPlate_status__1Z3Kh","icon":"TransactionStatusPlate_icon__2BJmz"};